import { render } from "./SectionTwo.vue?vue&type=template&id=2441f004"
import script from "./SectionTwo.vue?vue&type=script&lang=js"
export * from "./SectionTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__